var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Issue",class:[_vm.level]},[_c('WText',[_c('WText',{staticClass:"Status",class:[_vm.level],attrs:{"size":14,"tag":"span","weight":"semi","uppercase":""}},[_vm._v(" "+_vm._s(_vm.$tc(`imports.create.notifications.${_vm.level}`))+" ")]),_c('WText',{attrs:{"size":14,"tag":"span"}},[_vm._v(" - "+_vm._s(_vm.message)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }